import React from 'react';
import { Package, ChevronLeft, ChevronRight } from 'lucide-react';

const ImageGallery = ({ images, hasImages, currentIndex, setCurrentIndex, variantImageUrl, theme }) => {
  const currentImage = hasImages ? images[currentIndex] : null;
  const showVariantImage = !!variantImageUrl;
  
  const prevImage = () => {
    setCurrentIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const nextImage = () => {
    setCurrentIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };

  const displayedSrc = showVariantImage
    ? `${process.env.REACT_APP_BACKEND_URL}${variantImageUrl}`
    : currentImage ? `${process.env.REACT_APP_BACKEND_URL}${currentImage.url}` : null;

  return (
    <div className="space-y-3" data-testid="image-gallery">
      <div className="relative rounded-2xl overflow-hidden shadow-sm" style={{ backgroundColor: theme.cardBg, border: `1px solid ${theme.borderColor}` }}>
        <div className="aspect-square relative">
          {(hasImages || showVariantImage) && displayedSrc ? (
            <>
              <img 
                src={displayedSrc}
                alt="Product"
                className="w-full h-full object-contain p-4"
              />
              {images.length > 1 && !showVariantImage && (
                <>
                  <button 
                    className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full shadow-md flex items-center justify-center hover:shadow-lg transition-shadow"
                    style={{ backgroundColor: theme.cardBg, border: `1px solid ${theme.borderColor}` }}
                    onClick={prevImage}
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </button>
                  <button 
                    className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full shadow-md flex items-center justify-center hover:shadow-lg transition-shadow"
                    style={{ backgroundColor: theme.cardBg, border: `1px solid ${theme.borderColor}` }}
                    onClick={nextImage}
                  >
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </>
              )}
            </>
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center" style={{ opacity: 0.3 }}>
              <Package className="w-20 h-20 mb-3" />
              <span className="text-sm">Aucune image</span>
            </div>
          )}
        </div>
      </div>
      
      {images.length > 1 && !showVariantImage && (
        <div className="flex gap-2 overflow-x-auto pb-1">
          {images.map((img, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden border-2 shrink-0 transition-all"
              style={{
                borderColor: idx === currentIndex ? theme.accentColor : theme.borderColor,
                opacity: idx === currentIndex ? 1 : 0.6
              }}
            >
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}${img.url}`}
                alt={`Vue ${idx + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
